var validateNumber = (rule, value, callback) => {}

// export const form = {
//   profession: '',
//   spuCode: '',
//   skuCode: '',
//   title: '',
//   platTitle: '',
//   category1: ''
// }
export const rules = {
  // payment1: [
  //   { type: 'number', message: '请输入数字', trigger: 'blur' },
  // ],
  // payment2: [
  //   { type: 'number', message: '请输入数字', trigger: 'blur' },
  //   // { validator: validateNumber, trigger: 'change' }
  // ]
}

export const actionLineWithImport = [
  {
    name: '搜索',
    index: 1,
    handler: 'handleSearch',
    props: {
      type: '',
      size: 'medium'
    }
  },
  {
    name: '重置',
    index: 2,
    handler: 'clearSearch',
    props: {
      type: '',
      size: 'medium'
    }
  },
  {
    name: '导入',
    index: 4,
    handler: 'handleImport',
    props: {
      type: 'primary',
      size: 'medium'
    }
  }
]



// WEBPACK FOOTER //
// ./src/views/rfm/rfmPrdList/data.js